import { default as aboutcIQiaQZcL5Meta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsiWU9nutnCeMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93qKTSGjLzi0Meta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleTeeRyEJxztMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45products38YCuLaR8RMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93F2zilCv4HBMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewipwkjTXFMMMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as index6pSW1e7YqWMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_936FqoLRNCMrMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as index2CXXve5ngeMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93eXufU0jJ0PMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexF5RhV1Jl5nMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessions2unIwT1sqpMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordings2ykNqZ4HGAMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviews4F9Pn0eTiqMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93A2fKwHGg5UMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexLzsRm52PfJMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmr66oBFZhHkMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmvXR2opVAyXMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendaryGTA9hi8sxMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatsDqvYtRV41Meta } from "/tmp/build_ec1baafa/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutFpheRXIb3lMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedskWr0U1rxtMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersFDkPnOvJ3TMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93mluID7uh3DMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editMLCJIbeuo7Meta } from "/tmp/build_ec1baafa/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93nZst2NAzwGMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityViegRWdcVaMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93dspWWIMMoCMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93kGHEjKLUbNMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardnko04PyEjEMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexsOMThFwSyoMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutvqLulX0crHMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45producty3TZeoAQQqMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventssOxfLcnTp5Meta } from "/tmp/build_ec1baafa/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93n0CEMu0xp9Meta } from "/tmp/build_ec1baafa/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexuBatwNrIY4Meta } from "/tmp/build_ec1baafa/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93hBoXlQjTwIMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93Ak3L5c5qNzMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexsCscyRWljmMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93nqsSuBUKp3Meta } from "/tmp/build_ec1baafa/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as join4zv28PIiU1Meta } from "/tmp/build_ec1baafa/pages/[studio_url]/join.vue?macro=true";
import { default as loginknaoyqGkftMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/login.vue?macro=true";
import { default as logout8sgK8AGH2AMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93GDgRH3UDPqMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_930SEkdWNRevMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93lhvaf0hJnFMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favorites2S6VyeVfFQMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studioshMdTwIaZuZMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinsUpDhZgDa4Meta } from "/tmp/build_ec1baafa/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93sbVMrqe1xeMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexNIWj2WXT7KMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as indexOxr7j8OZSuMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutV0a7e1GUXLMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentYiCVsO30BnMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventspOICqWKxweMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93553jyXvb3sMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sample5Omu4VMEADMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45products47UeydaMVxMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93EKGzCsg8h0Meta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewNoT14wdroKMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as index0GDsyntMsEMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93EKiOic3jFrMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexmEOnTJBkImMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93wgPxF7JKSmMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexu7DIfsWi6SMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessions20wpW7Y2csMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordings3Hddiccb3vMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewstFUTNlzYMTMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93GYtN06VqFmMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexAwsc0UqNl1Meta } from "/tmp/build_ec1baafa/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexj38IOoYnSQMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesZAwKXBg3oJMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsEIcqkmK8QXMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93I1zVI17CewMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93DNM70ILAyQMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetv0KOM8ycx9Meta } from "/tmp/build_ec1baafa/pages/[studio_url]/reset.vue?macro=true";
import { default as shopf1VNzLjnS2Meta } from "/tmp/build_ec1baafa/pages/[studio_url]/shop.vue?macro=true";
import { default as signup9V3F5bNY2LMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/signup.vue?macro=true";
import { default as live3PJZtLj29xMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsJ70FU8dGg3Meta } from "/tmp/build_ec1baafa/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93fQvzt7o0oLMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactURyiVRjrUTMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as full0DW4KTLWLyMeta } from "/tmp/build_ec1baafa/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93A2fKwHGg5UMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93A2fKwHGg5UMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93A2fKwHGg5UMeta || {},
    alias: _91product_id_93A2fKwHGg5UMeta?.alias || [],
    redirect: _91product_id_93A2fKwHGg5UMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutcIQiaQZcL5Meta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutcIQiaQZcL5Meta?.path ?? "about",
    meta: aboutcIQiaQZcL5Meta || {},
    alias: aboutcIQiaQZcL5Meta?.alias || [],
    redirect: aboutcIQiaQZcL5Meta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsiWU9nutnCeMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsiWU9nutnCeMeta?.path ?? "events",
    meta: eventsiWU9nutnCeMeta || {},
    alias: eventsiWU9nutnCeMeta?.alias || [],
    redirect: eventsiWU9nutnCeMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93qKTSGjLzi0Meta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93qKTSGjLzi0Meta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93qKTSGjLzi0Meta || {},
    alias: _91media_id_93qKTSGjLzi0Meta?.alias || [],
    redirect: _91media_id_93qKTSGjLzi0Meta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleTeeRyEJxztMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sampleTeeRyEJxztMeta?.path ?? "free-sample",
    meta: free_45sampleTeeRyEJxztMeta || {},
    alias: free_45sampleTeeRyEJxztMeta?.alias || [],
    redirect: free_45sampleTeeRyEJxztMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45products38YCuLaR8RMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45products38YCuLaR8RMeta?.path ?? "included-products",
    meta: included_45products38YCuLaR8RMeta || {},
    alias: included_45products38YCuLaR8RMeta?.alias || [],
    redirect: included_45products38YCuLaR8RMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93F2zilCv4HBMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93F2zilCv4HBMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93F2zilCv4HBMeta || {},
    alias: _91media_id_93F2zilCv4HBMeta?.alias || [],
    redirect: _91media_id_93F2zilCv4HBMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewipwkjTXFMMMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewipwkjTXFMMMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewipwkjTXFMMMeta || {},
    alias: viewipwkjTXFMMMeta?.alias || [],
    redirect: viewipwkjTXFMMMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: index6pSW1e7YqWMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: index6pSW1e7YqWMeta?.path ?? "lessons",
    meta: index6pSW1e7YqWMeta || {},
    alias: index6pSW1e7YqWMeta?.alias || [],
    redirect: index6pSW1e7YqWMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_936FqoLRNCMrMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_936FqoLRNCMrMeta?.path ?? "media/:media_id()",
    meta: _91media_id_936FqoLRNCMrMeta || {},
    alias: _91media_id_936FqoLRNCMrMeta?.alias || [],
    redirect: _91media_id_936FqoLRNCMrMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: index2CXXve5ngeMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: index2CXXve5ngeMeta?.path ?? "playlists/:playlist_id()",
    meta: index2CXXve5ngeMeta || {},
    alias: index2CXXve5ngeMeta?.alias || [],
    redirect: index2CXXve5ngeMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93eXufU0jJ0PMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93eXufU0jJ0PMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93eXufU0jJ0PMeta || {},
    alias: _91media_id_93eXufU0jJ0PMeta?.alias || [],
    redirect: _91media_id_93eXufU0jJ0PMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexF5RhV1Jl5nMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexF5RhV1Jl5nMeta?.path ?? "playlists",
    meta: indexF5RhV1Jl5nMeta || {},
    alias: indexF5RhV1Jl5nMeta?.alias || [],
    redirect: indexF5RhV1Jl5nMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessions2unIwT1sqpMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessions2unIwT1sqpMeta?.path ?? "private-sessions",
    meta: private_45sessions2unIwT1sqpMeta || {},
    alias: private_45sessions2unIwT1sqpMeta?.alias || [],
    redirect: private_45sessions2unIwT1sqpMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordings2ykNqZ4HGAMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordings2ykNqZ4HGAMeta?.path ?? "recordings",
    meta: recordings2ykNqZ4HGAMeta || {},
    alias: recordings2ykNqZ4HGAMeta?.alias || [],
    redirect: recordings2ykNqZ4HGAMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviews4F9Pn0eTiqMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviews4F9Pn0eTiqMeta?.path ?? "reviews",
    meta: reviews4F9Pn0eTiqMeta || {},
    alias: reviews4F9Pn0eTiqMeta?.alias || [],
    redirect: reviews4F9Pn0eTiqMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexLzsRm52PfJMeta?.name ?? "buy-product-product_id",
    path: indexLzsRm52PfJMeta?.path ?? "/buy/product/:product_id()",
    meta: indexLzsRm52PfJMeta || {},
    alias: indexLzsRm52PfJMeta?.alias || [],
    redirect: indexLzsRm52PfJMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmr66oBFZhHkMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmr66oBFZhHkMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmr66oBFZhHkMeta || {},
    alias: confirmr66oBFZhHkMeta?.alias || [],
    redirect: confirmr66oBFZhHkMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmvXR2opVAyXMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmvXR2opVAyXMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmvXR2opVAyXMeta || {},
    alias: confirmvXR2opVAyXMeta?.alias || [],
    redirect: confirmvXR2opVAyXMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendaryGTA9hi8sxMeta?.name ?? "calendar",
    path: calendaryGTA9hi8sxMeta?.path ?? "/calendar",
    meta: calendaryGTA9hi8sxMeta || {},
    alias: calendaryGTA9hi8sxMeta?.alias || [],
    redirect: calendaryGTA9hi8sxMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatsDqvYtRV41Meta?.name ?? "chat",
    path: chatsDqvYtRV41Meta?.path ?? "/chat",
    meta: chatsDqvYtRV41Meta || {},
    alias: chatsDqvYtRV41Meta?.alias || [],
    redirect: chatsDqvYtRV41Meta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93mluID7uh3DMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93mluID7uh3DMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93mluID7uh3DMeta || {},
    alias: _91group_id_93mluID7uh3DMeta?.alias || [],
    redirect: _91group_id_93mluID7uh3DMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutFpheRXIb3lMeta?.name ?? "community-groups-group_id-about",
    path: aboutFpheRXIb3lMeta?.path ?? "about",
    meta: aboutFpheRXIb3lMeta || {},
    alias: aboutFpheRXIb3lMeta?.alias || [],
    redirect: aboutFpheRXIb3lMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedskWr0U1rxtMeta?.name ?? "community-groups-group_id-feed",
    path: feedskWr0U1rxtMeta?.path ?? "feed",
    meta: feedskWr0U1rxtMeta || {},
    alias: feedskWr0U1rxtMeta?.alias || [],
    redirect: feedskWr0U1rxtMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersFDkPnOvJ3TMeta?.name ?? "community-groups-group_id-members",
    path: membersFDkPnOvJ3TMeta?.path ?? "members",
    meta: membersFDkPnOvJ3TMeta || {},
    alias: membersFDkPnOvJ3TMeta?.alias || [],
    redirect: membersFDkPnOvJ3TMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editMLCJIbeuo7Meta?.name ?? "community-profile-edit",
    path: community_45profile_45editMLCJIbeuo7Meta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editMLCJIbeuo7Meta || {},
    alias: community_45profile_45editMLCJIbeuo7Meta?.alias || [],
    redirect: community_45profile_45editMLCJIbeuo7Meta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93nZst2NAzwGMeta?.name ?? "community-profile-id",
    path: _91id_93nZst2NAzwGMeta?.path ?? "/community-profile/:id()",
    meta: _91id_93nZst2NAzwGMeta || {},
    alias: _91id_93nZst2NAzwGMeta?.alias || [],
    redirect: _91id_93nZst2NAzwGMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityViegRWdcVaMeta?.name ?? "community",
    path: communityViegRWdcVaMeta?.path ?? "/community",
    meta: communityViegRWdcVaMeta || {},
    alias: communityViegRWdcVaMeta?.alias || [],
    redirect: communityViegRWdcVaMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93dspWWIMMoCMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93dspWWIMMoCMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93dspWWIMMoCMeta || {},
    alias: _91uuid_93dspWWIMMoCMeta?.alias || [],
    redirect: _91uuid_93dspWWIMMoCMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93kGHEjKLUbNMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_93kGHEjKLUbNMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93kGHEjKLUbNMeta || {},
    alias: _91unique_id_93kGHEjKLUbNMeta?.alias || [],
    redirect: _91unique_id_93kGHEjKLUbNMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardnko04PyEjEMeta?.name ?? "dashboard",
    path: dashboardnko04PyEjEMeta?.path ?? "/dashboard",
    meta: dashboardnko04PyEjEMeta || {},
    alias: dashboardnko04PyEjEMeta?.alias || [],
    redirect: dashboardnko04PyEjEMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexsOMThFwSyoMeta?.name ?? "event-details-event_id",
    path: indexsOMThFwSyoMeta?.path ?? "/event/details/:event_id()",
    meta: indexsOMThFwSyoMeta || {},
    alias: indexsOMThFwSyoMeta?.alias || [],
    redirect: indexsOMThFwSyoMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutvqLulX0crHMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutvqLulX0crHMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutvqLulX0crHMeta || {},
    alias: checkoutvqLulX0crHMeta?.alias || [],
    redirect: checkoutvqLulX0crHMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45producty3TZeoAQQqMeta?.name ?? "event-details-event_id-select-product",
    path: select_45producty3TZeoAQQqMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45producty3TZeoAQQqMeta || {},
    alias: select_45producty3TZeoAQQqMeta?.alias || [],
    redirect: select_45producty3TZeoAQQqMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventssOxfLcnTp5Meta?.name ?? "events",
    path: eventssOxfLcnTp5Meta?.path ?? "/events",
    meta: eventssOxfLcnTp5Meta || {},
    alias: eventssOxfLcnTp5Meta?.alias || [],
    redirect: eventssOxfLcnTp5Meta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93n0CEMu0xp9Meta?.name ?? "gifts-uuid",
    path: _91uuid_93n0CEMu0xp9Meta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93n0CEMu0xp9Meta || {},
    alias: _91uuid_93n0CEMu0xp9Meta?.alias || [],
    redirect: _91uuid_93n0CEMu0xp9Meta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexuBatwNrIY4Meta?.name ?? "gifts",
    path: indexuBatwNrIY4Meta?.path ?? "/gifts",
    meta: indexuBatwNrIY4Meta || {},
    alias: indexuBatwNrIY4Meta?.alias || [],
    redirect: indexuBatwNrIY4Meta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93hBoXlQjTwIMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93hBoXlQjTwIMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93hBoXlQjTwIMeta || {},
    alias: _91invitation_id_93hBoXlQjTwIMeta?.alias || [],
    redirect: _91invitation_id_93hBoXlQjTwIMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93Ak3L5c5qNzMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93Ak3L5c5qNzMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93Ak3L5c5qNzMeta || {},
    alias: _91product_id_93Ak3L5c5qNzMeta?.alias || [],
    redirect: _91product_id_93Ak3L5c5qNzMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexsCscyRWljmMeta?.name ?? "index",
    path: indexsCscyRWljmMeta?.path ?? "/",
    meta: indexsCscyRWljmMeta || {},
    alias: indexsCscyRWljmMeta?.alias || [],
    redirect: indexsCscyRWljmMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93nqsSuBUKp3Meta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93nqsSuBUKp3Meta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93nqsSuBUKp3Meta || {},
    alias: _91invitation_unique_id_93nqsSuBUKp3Meta?.alias || [],
    redirect: _91invitation_unique_id_93nqsSuBUKp3Meta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: join4zv28PIiU1Meta?.name ?? "join",
    path: join4zv28PIiU1Meta?.path ?? "/join",
    meta: join4zv28PIiU1Meta || {},
    alias: join4zv28PIiU1Meta?.alias || [],
    redirect: join4zv28PIiU1Meta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginknaoyqGkftMeta?.name ?? "login",
    path: loginknaoyqGkftMeta?.path ?? "/login",
    meta: loginknaoyqGkftMeta || {},
    alias: loginknaoyqGkftMeta?.alias || [],
    redirect: loginknaoyqGkftMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logout8sgK8AGH2AMeta?.name ?? "logout",
    path: logout8sgK8AGH2AMeta?.path ?? "/logout",
    meta: logout8sgK8AGH2AMeta || {},
    alias: logout8sgK8AGH2AMeta?.alias || [],
    redirect: logout8sgK8AGH2AMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93GDgRH3UDPqMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93GDgRH3UDPqMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93GDgRH3UDPqMeta || {},
    alias: _91meeting_type_slug_93GDgRH3UDPqMeta?.alias || [],
    redirect: _91meeting_type_slug_93GDgRH3UDPqMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_930SEkdWNRevMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_930SEkdWNRevMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_930SEkdWNRevMeta || {},
    alias: _91meeting_unique_id_930SEkdWNRevMeta?.alias || [],
    redirect: _91meeting_unique_id_930SEkdWNRevMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93lhvaf0hJnFMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93lhvaf0hJnFMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93lhvaf0hJnFMeta || {},
    alias: _91meeting_unique_id_93lhvaf0hJnFMeta?.alias || [],
    redirect: _91meeting_unique_id_93lhvaf0hJnFMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favorites2S6VyeVfFQMeta?.name ?? "my-favorites",
    path: my_45favorites2S6VyeVfFQMeta?.path ?? "/my-favorites",
    meta: my_45favorites2S6VyeVfFQMeta || {},
    alias: my_45favorites2S6VyeVfFQMeta?.alias || [],
    redirect: my_45favorites2S6VyeVfFQMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studioshMdTwIaZuZMeta?.name ?? "my-studios",
    path: my_45studioshMdTwIaZuZMeta?.path ?? "/my-studios",
    meta: my_45studioshMdTwIaZuZMeta || {},
    alias: my_45studioshMdTwIaZuZMeta?.alias || [],
    redirect: my_45studioshMdTwIaZuZMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinsUpDhZgDa4Meta?.name ?? "optin",
    path: optinsUpDhZgDa4Meta?.path ?? "/optin",
    meta: optinsUpDhZgDa4Meta || {},
    alias: optinsUpDhZgDa4Meta?.alias || [],
    redirect: optinsUpDhZgDa4Meta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93sbVMrqe1xeMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93sbVMrqe1xeMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93sbVMrqe1xeMeta || {},
    alias: _91episode_id_93sbVMrqe1xeMeta?.alias || [],
    redirect: _91episode_id_93sbVMrqe1xeMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexNIWj2WXT7KMeta?.name ?? "podcasts-podcast_id",
    path: indexNIWj2WXT7KMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexNIWj2WXT7KMeta || {},
    alias: indexNIWj2WXT7KMeta?.alias || [],
    redirect: indexNIWj2WXT7KMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexOxr7j8OZSuMeta?.name ?? "podcasts",
    path: indexOxr7j8OZSuMeta?.path ?? "/podcasts",
    meta: indexOxr7j8OZSuMeta || {},
    alias: indexOxr7j8OZSuMeta?.alias || [],
    redirect: indexOxr7j8OZSuMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93GYtN06VqFmMeta?.name ?? "product-product_id",
    path: _91product_id_93GYtN06VqFmMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93GYtN06VqFmMeta || {},
    alias: _91product_id_93GYtN06VqFmMeta?.alias || [],
    redirect: _91product_id_93GYtN06VqFmMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutV0a7e1GUXLMeta?.name ?? "product-product_id-about",
    path: aboutV0a7e1GUXLMeta?.path ?? "about",
    meta: aboutV0a7e1GUXLMeta || {},
    alias: aboutV0a7e1GUXLMeta?.alias || [],
    redirect: aboutV0a7e1GUXLMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentYiCVsO30BnMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentYiCVsO30BnMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contentYiCVsO30BnMeta || {},
    alias: digital_45download_45contentYiCVsO30BnMeta?.alias || [],
    redirect: digital_45download_45contentYiCVsO30BnMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventspOICqWKxweMeta?.name ?? "product-product_id-events",
    path: eventspOICqWKxweMeta?.path ?? "events",
    meta: eventspOICqWKxweMeta || {},
    alias: eventspOICqWKxweMeta?.alias || [],
    redirect: eventspOICqWKxweMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93553jyXvb3sMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93553jyXvb3sMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93553jyXvb3sMeta || {},
    alias: _91media_id_93553jyXvb3sMeta?.alias || [],
    redirect: _91media_id_93553jyXvb3sMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sample5Omu4VMEADMeta?.name ?? "product-product_id-free-sample",
    path: free_45sample5Omu4VMEADMeta?.path ?? "free-sample",
    meta: free_45sample5Omu4VMEADMeta || {},
    alias: free_45sample5Omu4VMEADMeta?.alias || [],
    redirect: free_45sample5Omu4VMEADMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45products47UeydaMVxMeta?.name ?? "product-product_id-included-products",
    path: included_45products47UeydaMVxMeta?.path ?? "included-products",
    meta: included_45products47UeydaMVxMeta || {},
    alias: included_45products47UeydaMVxMeta?.alias || [],
    redirect: included_45products47UeydaMVxMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93EKGzCsg8h0Meta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93EKGzCsg8h0Meta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93EKGzCsg8h0Meta || {},
    alias: _91media_id_93EKGzCsg8h0Meta?.alias || [],
    redirect: _91media_id_93EKGzCsg8h0Meta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewNoT14wdroKMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewNoT14wdroKMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewNoT14wdroKMeta || {},
    alias: viewNoT14wdroKMeta?.alias || [],
    redirect: viewNoT14wdroKMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: index0GDsyntMsEMeta?.name ?? "product-product_id-lessons",
    path: index0GDsyntMsEMeta?.path ?? "lessons",
    meta: index0GDsyntMsEMeta || {},
    alias: index0GDsyntMsEMeta?.alias || [],
    redirect: index0GDsyntMsEMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93EKiOic3jFrMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93EKiOic3jFrMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93EKiOic3jFrMeta || {},
    alias: _91media_id_93EKiOic3jFrMeta?.alias || [],
    redirect: _91media_id_93EKiOic3jFrMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexmEOnTJBkImMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexmEOnTJBkImMeta?.path ?? "playlists/:playlist_id()",
    meta: indexmEOnTJBkImMeta || {},
    alias: indexmEOnTJBkImMeta?.alias || [],
    redirect: indexmEOnTJBkImMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93wgPxF7JKSmMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93wgPxF7JKSmMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93wgPxF7JKSmMeta || {},
    alias: _91media_id_93wgPxF7JKSmMeta?.alias || [],
    redirect: _91media_id_93wgPxF7JKSmMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexu7DIfsWi6SMeta?.name ?? "product-product_id-playlists",
    path: indexu7DIfsWi6SMeta?.path ?? "playlists",
    meta: indexu7DIfsWi6SMeta || {},
    alias: indexu7DIfsWi6SMeta?.alias || [],
    redirect: indexu7DIfsWi6SMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessions20wpW7Y2csMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessions20wpW7Y2csMeta?.path ?? "private-sessions",
    meta: private_45sessions20wpW7Y2csMeta || {},
    alias: private_45sessions20wpW7Y2csMeta?.alias || [],
    redirect: private_45sessions20wpW7Y2csMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordings3Hddiccb3vMeta?.name ?? "product-product_id-recordings",
    path: recordings3Hddiccb3vMeta?.path ?? "recordings",
    meta: recordings3Hddiccb3vMeta || {},
    alias: recordings3Hddiccb3vMeta?.alias || [],
    redirect: recordings3Hddiccb3vMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewstFUTNlzYMTMeta?.name ?? "product-product_id-reviews",
    path: reviewstFUTNlzYMTMeta?.path ?? "reviews",
    meta: reviewstFUTNlzYMTMeta || {},
    alias: reviewstFUTNlzYMTMeta?.alias || [],
    redirect: reviewstFUTNlzYMTMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexAwsc0UqNl1Meta?.name ?? "product",
    path: indexAwsc0UqNl1Meta?.path ?? "/product",
    meta: indexAwsc0UqNl1Meta || {},
    alias: indexAwsc0UqNl1Meta?.alias || [],
    redirect: indexAwsc0UqNl1Meta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexj38IOoYnSQMeta?.name ?? "profile",
    path: indexj38IOoYnSQMeta?.path ?? "/profile",
    meta: indexj38IOoYnSQMeta || {},
    alias: indexj38IOoYnSQMeta?.alias || [],
    redirect: indexj38IOoYnSQMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesZAwKXBg3oJMeta?.name ?? "profile-purchases",
    path: purchasesZAwKXBg3oJMeta?.path ?? "/profile/purchases",
    meta: purchasesZAwKXBg3oJMeta || {},
    alias: purchasesZAwKXBg3oJMeta?.alias || [],
    redirect: purchasesZAwKXBg3oJMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsEIcqkmK8QXMeta?.name ?? "profile-redemptions",
    path: redemptionsEIcqkmK8QXMeta?.path ?? "/profile/redemptions",
    meta: redemptionsEIcqkmK8QXMeta || {},
    alias: redemptionsEIcqkmK8QXMeta?.alias || [],
    redirect: redemptionsEIcqkmK8QXMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93I1zVI17CewMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93I1zVI17CewMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93I1zVI17CewMeta || {},
    alias: _91quiz_id_93I1zVI17CewMeta?.alias || [],
    redirect: _91quiz_id_93I1zVI17CewMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93DNM70ILAyQMeta?.name ?? "reset-password-uid-token",
    path: _91token_93DNM70ILAyQMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93DNM70ILAyQMeta || {},
    alias: _91token_93DNM70ILAyQMeta?.alias || [],
    redirect: _91token_93DNM70ILAyQMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetv0KOM8ycx9Meta?.name ?? "reset",
    path: resetv0KOM8ycx9Meta?.path ?? "/reset",
    meta: resetv0KOM8ycx9Meta || {},
    alias: resetv0KOM8ycx9Meta?.alias || [],
    redirect: resetv0KOM8ycx9Meta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopf1VNzLjnS2Meta?.name ?? "shop",
    path: shopf1VNzLjnS2Meta?.path ?? "/shop",
    meta: shopf1VNzLjnS2Meta || {},
    alias: shopf1VNzLjnS2Meta?.alias || [],
    redirect: shopf1VNzLjnS2Meta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signup9V3F5bNY2LMeta?.name ?? "signup",
    path: signup9V3F5bNY2LMeta?.path ?? "/signup",
    meta: signup9V3F5bNY2LMeta || {},
    alias: signup9V3F5bNY2LMeta?.alias || [],
    redirect: signup9V3F5bNY2LMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: live3PJZtLj29xMeta?.name ?? "streaming-event_id-live",
    path: live3PJZtLj29xMeta?.path ?? "/streaming/:event_id()/live",
    meta: live3PJZtLj29xMeta || {},
    alias: live3PJZtLj29xMeta?.alias || [],
    redirect: live3PJZtLj29xMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsJ70FU8dGg3Meta?.name ?? "tips",
    path: tipsJ70FU8dGg3Meta?.path ?? "/tips",
    meta: tipsJ70FU8dGg3Meta || {},
    alias: tipsJ70FU8dGg3Meta?.alias || [],
    redirect: tipsJ70FU8dGg3Meta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93fQvzt7o0oLMeta?.name ?? "waiver-uuid",
    path: _91uuid_93fQvzt7o0oLMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93fQvzt7o0oLMeta || {},
    alias: _91uuid_93fQvzt7o0oLMeta?.alias || [],
    redirect: _91uuid_93fQvzt7o0oLMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactURyiVRjrUTMeta?.name ?? "widgets-calendars-compact",
    path: compactURyiVRjrUTMeta?.path ?? "/widgets/calendars/compact",
    meta: compactURyiVRjrUTMeta || {},
    alias: compactURyiVRjrUTMeta?.alias || [],
    redirect: compactURyiVRjrUTMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: full0DW4KTLWLyMeta?.name ?? "widgets-calendars-full",
    path: full0DW4KTLWLyMeta?.path ?? "/widgets/calendars/full",
    meta: full0DW4KTLWLyMeta || {},
    alias: full0DW4KTLWLyMeta?.alias || [],
    redirect: full0DW4KTLWLyMeta?.redirect,
    component: () => import("/tmp/build_ec1baafa/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]